import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=69d9bfcd&scoped=true&"
import script from "./IconLink.vue?vue&type=script&lang=js&"
export * from "./IconLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d9bfcd",
  null
  
)

export default component.exports